import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { getAPI, postAPI, reinitialiseAPI } from 'store/apiReducer';
import * as PropTypes from 'prop-types';
import {
    Modale,
    ModaleTitre,
    ModaleContent,
    ModaleFooter,
    GroupeBouton,
    Bouton,
    Row,
    Col,
} from '@design-system-etat/dsfr-react';

import { useForm, FormProvider } from 'react-hook-form';
import InputFiles from 'components/Commun/Form/InputFiles';
import {
    tailleFichiers,
    formatFichiers,
    mimeTypesAccepted,
} from './ModaleModifierPiecesJointes.constants';
import formaterCompleterDemandePiecesJointes from './FormaterCompleterDemandePiecesJointes';
import usagerClientReducer from '../../../../../store/usagerReducer';
import {
    API_COMPLETER_DEMANDE_PIECES_JOINTES,
    API_GET_LISTE_PIECES_MANQUANTES_DECLARATION_ARMES,
    API_GET_MES_DEMARCHES_EN_COURS,
    CONTEXT_COMPLETER_DEMANDE_PIECES_JOINTES,
    CONTEXT_GET_LISTE_PIECES_MANQUANTES_DECLARATION_ARMES,
    CONTEXT_MES_DEMARCHES_EN_COURS,
} from '../../../../../constants/apiUrls.constants';

const ModaleModifierPiecesJointes = ({
    fermerModale,
    listePiecesJointesAmodifier,
    postApi,
    getApi,
    isLoading,
    isLoadingEnvoyerPJ,
    messagePjsEnvoyees,
    codeStatutPjsEnvoyees,
    uuidDeclaration,
}) => {
    const hookForm = useForm({
        mode: 'onChange',
    });
    const { register, handleSubmit, formState, getValues } = hookForm;

    // le formulaire est valide quand toutes les PJs sont renseignées
    const hasFormValid = () => {
        let formulaireEstvalide = false;
        let indexContenuForm = null;

        if (listePiecesJointesAmodifier) {
            listePiecesJointesAmodifier.map((key, index) => {
                indexContenuForm =
                    getValues(`${key.clePieceJointe}`) &&
                    getValues(`${key.clePieceJointe}`).length > 0;

                if (index === 0) {
                    formulaireEstvalide = indexContenuForm;
                } else {
                    formulaireEstvalide = formulaireEstvalide && indexContenuForm;
                }
                return indexContenuForm;
            });
        }
        return formulaireEstvalide;
    };

    // Récupérer la liste des pièces jointes à compléter
    useEffect(() => {
        if (!Array.isArray(listePiecesJointesAmodifier)) {
            getApi(
                usagerClientReducer,
                `${API_GET_LISTE_PIECES_MANQUANTES_DECLARATION_ARMES}?uuidDeclaration=${uuidDeclaration}`,
                CONTEXT_GET_LISTE_PIECES_MANQUANTES_DECLARATION_ARMES,
            );
        }
    }, []);

    useEffect(() => {
        if (messagePjsEnvoyees && codeStatutPjsEnvoyees === 200) {
            fermerModale();
        }
    }, [messagePjsEnvoyees, codeStatutPjsEnvoyees]);

    const onSubmit = async () => {
        if (hasFormValid()) {
            const piecesIdentite = getValues('piecesIdentite');
            const permisDeChasse = getValues('permisChasse');
            const validationPermisChasserFichier = getValues('validationPermisChasserFichier');
            const licenceDeTir = getValues('licenceTir');
            const licenceDeBallTrap = getValues('licenceBallTrap');
            const licenceDeSki = getValues('licenceSki');
            const justificatifDeDomicile = getValues('justificatifDomicile');
            const certificatMedical = getValues('certificatMedical');
            const attestationHebergementFichier = getValues('attestationHebergementFichier');
            const pieceIdentiteHebergeurFichier = getValues('pieceIdentiteHebergeurFichier');
            const justificatifDomicileHebergeurFichier = getValues(
                'justificatifDomicileHebergeurFichier',
            );

            const dataFormat = await formaterCompleterDemandePiecesJointes(
                piecesIdentite,
                permisDeChasse,
                validationPermisChasserFichier,
                licenceDeTir,
                licenceDeBallTrap,
                licenceDeSki,
                justificatifDeDomicile,
                certificatMedical,
                uuidDeclaration,
                attestationHebergementFichier,
                pieceIdentiteHebergeurFichier,
                justificatifDomicileHebergeurFichier,
            );

            postApi(
                usagerClientReducer,
                API_COMPLETER_DEMANDE_PIECES_JOINTES,
                dataFormat,
                CONTEXT_COMPLETER_DEMANDE_PIECES_JOINTES,
            );

            getApi(
                usagerClientReducer,
                API_GET_MES_DEMARCHES_EN_COURS,
                CONTEXT_MES_DEMARCHES_EN_COURS,
            );
        }
    };

    const afficherListePiecesJointes = () => {
        if (listePiecesJointesAmodifier) {
            return listePiecesJointesAmodifier.map((key) => {
                return (
                    <Row goutierre>
                        <Col col={9}>
                            <InputFiles
                                name={key.clePieceJointe}
                                register={register(key.clePieceJointe, {
                                    validate: {
                                        tailleTotaleMoinsDe18MBAccepte: (fichiers) =>
                                            tailleFichiers(fichiers) <= 18874368 ||
                                            'La taille totale des fichier dépasse 18Mo',
                                        formatAccepte: (fichiers) =>
                                            formatFichiers(fichiers, mimeTypesAccepted) ||
                                            "Le format d'un des fichiers n'est pas accepté",
                                    },
                                })}
                                multiple
                                error={
                                    formState.errors ? formState.errors[key.clePieceJointe] : null
                                }
                                required
                                label={key.nomPieceJointe}
                            />
                        </Col>
                    </Row>
                );
            });
        }
        return null;
    };

    return (
        <>
            <FormProvider {...hookForm}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Modale taille="lg" closeCallback={fermerModale}>
                        <ModaleTitre>Modification de pièces</ModaleTitre>
                        <ModaleContent>
                            <p>
                                Une ou plusieurs des pièces constituant votre dossier de déclaration
                                de détention et d&apos;acquisition sont illisibles ou invalides.
                            </p>
                            <p>
                                Veuillez cliquer sur &apos;&apos;Importer&apos;&apos; afin de
                                sélectionner sélectionner pour chaque élément demandé une pièce
                                lisible et valide. Une fois toutes les pièces importées, veuillez
                                bouton &apos;&apos;Valider&apos;&apos;.
                            </p>
                            {afficherListePiecesJointes()}
                        </ModaleContent>
                        <ModaleFooter>
                            <GroupeBouton alignementHorizontal="right" isHorizontal>
                                <Bouton
                                    name="retour"
                                    label="Retour"
                                    onClick={fermerModale}
                                    disabled={isLoading}
                                />
                                <Bouton
                                    label="Valider"
                                    niveau="primaire"
                                    onClick={onSubmit}
                                    disabled={!hasFormValid()}
                                    isLoading={isLoading || isLoadingEnvoyerPJ}
                                />
                            </GroupeBouton>
                        </ModaleFooter>
                    </Modale>
                </form>
            </FormProvider>
        </>
    );
};

ModaleModifierPiecesJointes.propTypes = {
    fermerModale: PropTypes.func.isRequired,
    listePiecesJointesAmodifier: PropTypes.arrayOf(
        PropTypes.shape({
            uuidDeclaration: PropTypes.string.isRequired,
            clePieceJointe: PropTypes.string.isRequired,
            nomPieceJointe: PropTypes.string.isRequired,
            typePieceJointe: PropTypes.string,
            raisonDemande: PropTypes.string.isRequired,
            uuid: PropTypes.string.isRequired,
            dateInit: PropTypes.string.isRequired,
            dateMaj: PropTypes.string.isRequired,
        }),
    ),
    isLoading: PropTypes.bool,
    messagePjsEnvoyees: PropTypes.string,
    codeStatutPjsEnvoyees: PropTypes.number,
    isLoadingEnvoyerPJ: PropTypes.bool,
    postApi: PropTypes.func.isRequired,
    uuidDeclaration: PropTypes.string.isRequired,
    getApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
};

ModaleModifierPiecesJointes.defaultProps = {
    isLoading: false,
};

export default connect(
    (state) => {
        const { isLoading, data } = state.mesDeclarationsArmes.listePiecesManquantesDeclarationArme;
        const {
            isLoading: isLoadingEnvoyerPJ,
            message: messagePjsEnvoyees,
            codeStatut: codeStatutPjsEnvoyees,
        } = state.mesDeclarationsArmes.envoyerDemandePjs;
        return {
            isLoading,
            listePiecesJointesAmodifier: data,
            isLoadingEnvoyerPJ,
            messagePjsEnvoyees,
            codeStatutPjsEnvoyees,
        };
    },
    {
        getApi: getAPI,
        postApi: postAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(ModaleModifierPiecesJointes);
